module.exports = __webpack_public_path__ + "static/media/mg_logo.a89b7f32.svg";